export default __webpack_public_path__ + "static/media/hero_1024.68dc00ab.jpg";